import { Box, Container } from "@chakra-ui/react";
import { FreeDiscoveryCallForm } from "./FreeDiscoveryCallForm";

export const GetStarted = ({ cta }: { cta?: string }) => {
  return (
    <Box w="full" bgColor="brand.100">
      <Container maxW="container.xl">
        <FreeDiscoveryCallForm />
      </Container>
    </Box>
  );
};
